import angular from 'angular'

/**
 * ucFirst returns the input with the first character capitalized.
 */
export function ucFirst(input: string): string {
  if (typeof input !== 'string' || input.length === 0) {
    return input
  }
  return input.charAt(0).toUpperCase() + input.substr(1).toLowerCase()
}

angular.module('webregister.filters').filter('ucFirst', () => ucFirst)
